import { CheckList, Popup } from 'antd-mobile';
import React from 'react';
import { useAudioSpeed } from '../../zustand/handlers';

function SpeedPopUp() {
    const speed = useAudioSpeed();
    return (
        <>
            <Popup
                visible={speed.active}
                onMaskClick={() => {
                    speed.deactivate();
                }}
                destroyOnClose
            >
                <div
                // className={styles.checkListContainer}
                >
                    <CheckList
                        // className={styles.myCheckList}
                        defaultValue={[speed.value]}
                        onChange={val => {
                            const value = val[0];
                            speed.setValue(value)
                            speed.deactivate();
                            // setSelected(val[0])
                            // setVisible(false)

                        }}
                    >
                        {speed.list.map(({ value }) => (
                            <CheckList.Item key={value} value={value}>
                                {value}
                            </CheckList.Item>
                        ))}
                    </CheckList>
                </div>
            </Popup>
        </>
    )
}

export default SpeedPopUp